import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import AllChannelsQuery from 'GraphQueries/Channels/AllQuery';
import AllPurchaseModelsQuery from 'GraphQueries/PurchaseModels/AllQuery';
import GetWebsiteQuery from 'GraphQueries/Websites/GetQuery';
import UpdateWebsiteMutation from 'GraphQueries/Websites/UpdateMutation';

import PageNavigationTabs from 'Components/Presentation/_Shared/Layout/PageNavigationTabs';
import WebsiteEdit from 'Components/Presentation/Websites/WebsiteEdit';
import FormatList from 'Components/Presentation/Websites/Formats/FormatList';

class WebsiteEditContainer extends React.Component {

    static defaultProps = {
        website: { name: '', channel: { name: '' }, purchaseModelIds: {}, formats: [] },
        loading: false,
        pageTabs: [
            { label: 'Back To List', path: 'list', includeId: false },
            { label: 'Settings', path: 'manage/settings', includeId: true },
            { label: 'Formats', path: 'manage/formats', includeId: true } 
        ]
    }

    state = { 
        activeTabIndex: 1,
        saving: false
    }

    tabClickHandler = (el, key) => {
        const { history, match: { params } } = this.props;
        history.push(el.includeId ?
            `/organisations/websites/${params.id}/${el.path}` :
            `/organisations/websites/${el.path}`);
        this.setState({ activeTabIndex: key });
    }

    setActiveTab = index => {
        this.setState({ activeTabIndex: index });
    }

    navigateWithData = (uri) => {
        const { history } = this.props;
        history.push(uri);
    }

    saveWebsite = async (website, action = '') => {
        const { onAlert, onUpdate } = this.props;
        this.setState({ saving: true });

        delete website.__typename;
        delete website.channel;
        delete website.purchaseModels;

        onUpdate(website).then(x => {
            let message = '';
            switch (action) {
                case 'add_format':   
                    message = `Successfully added format to website: ${website.id}`;
                    break;
                case 'update_format':
                    message = `Successfully updated format on website: ${website.id}`;
                    break;
                case 'delete_format':
                    message = `Successfully deleted format on website: ${website.id}`;
                    break;
                default:
                    message = `Successfully updated website: ${website.id}`
                    break;                    
            }            
            this.setState({ saving: false });
            onAlert('success', `${message}`);
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to update websites, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    render() {
        const { website, channels, purchaseModels, loading, channelsLoading, purchaseModelsLoading, pageTabs } = this.props;
        const { activeTabIndex, saving } = this.state;
        return (
            <React.Fragment> 
                <PageNavigationTabs pageTabs={pageTabs} activeTabIndex={activeTabIndex} onTabClick={this.tabClickHandler} />
                <Route path="/organisations/websites/:id/manage/settings" render={props =>
                    <WebsiteEdit loading={loading || channelsLoading || purchaseModelsLoading || saving} website={website} 
                        channels={channels} channelsLoading={channelsLoading} 
                        purchaseModels={purchaseModels} purchaseModelsLoading={purchaseModelsLoading}
                        onWebsiteUpdated={this.saveWebsite} onActivate={event => this.setActiveTab(1)} />} />
                <Route path="/organisations/websites/:id/manage/formats" render={props =>
                    <FormatList website={website} loading={loading || saving} onWebsiteUpdated={this.saveWebsite} onActivate={event => this.setActiveTab(2)} />} />
            </React.Fragment>
        );
    }
}

export default 
    compose(
        graphql(AllChannelsQuery(), {
            props: ({ data: { listChannels, loading } }) => ({ channels: listChannels && listChannels.items, channelsLoading: loading })
        }),
        graphql(AllPurchaseModelsQuery(), {
            props: ({ data: { listPurchaseModels, loading } }) => ({ purchaseModels: listPurchaseModels && listPurchaseModels.items, purchaseModelsLoading: loading })
        }),
        graphql(GetWebsiteQuery, {
            options: ({ match: { params: { id } } }) => ({ variables: { id } }),
            props: ({ data: { getWebsite, loading } }) => ({ website: getWebsite, loading })
        }),
        graphql(UpdateWebsiteMutation(['channelId', 'purchaseModelIds', 'formats']), {
            props: ({ mutate }) => ({ onUpdate: input => mutate({ variables: { input } }) })            
        })
    )(WebsiteEditContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Websites/Edit.js